<form class="flex flex-col flex-grow" [formGroup]="formGroup()" (ngSubmit)="onSubmitPress()">
  <ng-content/>
  <p-button styleClass="w-full" [ngClass]="{
    'mt-auto': !noButtonPadding(),
    'font-bold': newButtonStyle()
  }" type="submit"
            [loading]="state() === 'loading'"
            [disabled]="this.formGroup().invalid"
            [severity]="newButtonStyle() ? 'contrast' : 'primary'"
  >
    {{submitButtonLabel()}}
  </p-button>
</form>
